<template>
  <div v-if="member">
    <div v-if="statusActivityFriendGetFriend" class="pa-0" style="margin-bottom: 5px;margin-top: 4px;"  @click="$router.push('/FriendGetFriend').catch(()=>{})">
        <v-card>
          <v-row style="justify-content: end;background: #FFB8A1;margin-top: 3px;">
                <v-col class="pa-0" cols="12" style="padding-top:10px;background-image: linear-gradient(180deg, rgb(255, 184, 161) 0%, rgb(305, 134, 111) 100%);" align="center">
                  <v-img src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/web%2Fget-friend.png?alt=media&token=b58ad331-64dd-472b-83fe-62b4c8ffd308" style="width: 305px; height: 135px;position: relative;" class="link">
                  <v-chip
                    style="position: absolute;left: -4px;bottom: 0;"
                    class="ma-2"
                    color="green"
                    text
                    text-color="white"
                  >
                  {{ $t("message.joinActivity") }}
                  </v-chip>
                  </v-img>
                </v-col>
            </v-row>
        </v-card>
    </div>
    <div class="mt-3">
        <v-row  v-if="showActivity">
          <v-col
          cols='12'
          class="px-7"
          v-for="(item, i) in items"
          :key="i"
          >
            <v-card class="pa-3 pt-1" :style="'background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);border-radius:17px;position: relative;'">
              <div style="margin-bottom: 5px;color: white;font-size: 18px;"><p class="mb-0" :style="'color:' + $textcolor">{{ checkTypeactivityFortexthearder(item)}} {{ shopId === 'U5bad3d6f53733785f626ceaeaad539f5' ? '10 คะแนน' : '' }}</p></div>
              <v-card class="image-input" :style="{
                                    'background-image': `url(${item.pictureUrl})`,
                                    'background-position': 'center center',
                                    'background-repeat': 'no-repeat',
                                    'border-radius': '17px',
                                    'display': 'none',
                                    'margin-bottom': '12px',
                                  }">
                <!-- <v-img
                  :src="item.pictureUrl"
                  contain
                  class="white--text align-end"
                  height="200px"
                > -->
                  <!-- <v-card-title v-text="item.title"></v-card-title> -->
                <!-- </v-img> -->
              </v-card>
              <v-card-text>
                <!-- <div style="color:white">{{item.title.substring(0, 22)}}</div>
                <div style="display:flex">
                  <div class="coin_icon_small" style="margin-right: 10px;">
                  </div>
                  <div style="color: white;" >
                      กดรับฟรี 10 คะแนน
                  </div>
                </div> -->
                <v-row>
                  <v-col cols="7" class="pa-4 pr-0">
                    <div :style="'color:' + $textcolor + ';border-bottom: solid 1px;'"  v-if="$i18n.locale === 'th' || item.titleEng === '' || item.titleEng === null">
                      {{item.title}}
                    </div>
                    <div :style="'color:' + $textcolor + ';border-bottom: solid 1px;'"  v-else-if="$i18n.locale === 'en'">
                      {{item.titleEng}}
                    </div>
                    <div style="display: flex;">
                      <div style="margin-right: 8px;padding-top: 10px;">
                         <div><img
                            v-if="profile.pictureUrl"
                            style="
                              border-color: white;
                              height: 25px;
                            "
                            alt="Avatar"
                            :src="require('@/assets/coin.png')"
                          /></div>
                      </div>
                      <div v-if="item.quota !== ''">
                        <div :style="$isTargetShop() ? {color: '#000', fontFamily: 'Cordia New'} : {color: $textcolor, fontFamily: 'kanit'}" class="text-caption">
                          {{ $t("message.claimFree") }} {{formatNumber(item.coin)}} {{ $t("message.point") }}
                        </div>
                        <div v-if="$i18n.locale === 'th'" :style="$isTargetShop() ? {color: '#000', fontFamily: 'Cordia New'} : {color: $textcolor, fontFamily: 'kanit'}" class="text-caption">
                          เหลืออีก {{formatNumber(item.quota - item.countUse)}} สิทธิ์
                        </div>
                        <div v-if="$i18n.locale === 'en'" :style="$isTargetShop() ? {color: '#000', fontFamily: 'Cordia New'} : {color: $textcolor, fontFamily: 'kanit'}" class="text-caption">
                          {{formatNumber(item.quota - item.countUse)}} {{ $t("message.privilegesRemaining") }}
                        </div>
                      </div>
                      <div v-if="item.quota === ''">
                        <div :style="$isTargetShop() ? {color: '#000', fontFamily: 'Cordia New'} : {color: $textcolor, fontFamily: 'kanit'}" class="text-caption">
                          {{ $t("message.claimFree") }} {{formatNumber(item.coin)}} {{ $t("message.point") }}
                        </div>
                        <div :style="$isTargetShop() ? {color: '#000', fontFamily: 'Cordia New'} : {color: $textcolor, fontFamily: 'kanit'}" class="text-caption">
                          {{ $t("message.NoLimitPrivileges") }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-row v-if="item.quota !== ''">
                    <v-col cols="5" style="margin: auto;justify-content: center;display: flex;" v-if="!item.statusChk && item.countUse < item.quota">
                    <v-btn class="btn" @click="submit(item)" >
                      {{ $t("message.getPoint") }}
                    </v-btn>
                    </v-col>
                    <v-col cols="5" style="margin: auto;justify-content: center;display: flex;" v-if="item.statusChk && item.countUse < item.quota">
                      <v-btn rounded color="#cfc9c9" @click="alertGetcoin" dark>
                        {{ $t("message.getPoint") }}
                      </v-btn>
                    </v-col>
                    <v-col cols="5" style="margin: auto;justify-content: center;display: flex;" v-if="(item.statusChk || !item.statusChk) && (item.quota - item.countUse === 0)">
                      <v-btn rounded color="#cfc9c9" @click="alertGetcoin" dark>
                        {{ $t("message.fullPrivilege") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="item.quota === ''">
                    <v-col cols="5" style="margin: auto;justify-content: center;display: flex;" v-if="!item.statusChk">
                    <v-btn class="btn" @click="submit(item)" >
                      {{ $t("message.getPoint") }}
                    </v-btn>
                    </v-col>
                    <v-col cols="5" style="margin: auto;justify-content: center;display: flex;" v-if="item.statusChk">
                      <v-btn rounded color="#cfc9c9" @click="alertGetcoin" dark>
                        {{ $t("message.getPoint") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card-text>
              <!-- <v-card-actions style="justify-content: center;position: absolute;
    bottom: -20px;right: 34px;">
                <div class="btn">
                  รับคะแนน
                </div>
              </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
      </div>
    <!-- <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        style="background-color: #0093AB; font-size: 20px; color: #fff;opacity: 0.6;"
      >
        กิจกรรมประจำวัน
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Daily')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            height="100"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">ใช้ได้ถึง {{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
          <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        style="background-color: #0093AB; font-size: 20px; color: #fff;opacity: 0.6;"
      >
        กิจกรรมประจำสัปดาห์
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Weekly')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            height="100"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">{{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
        <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div>
    <div>
      <div
        class="pa-2 pl-4 mb-5 mt-3"
        style="background-color: #0093AB; font-size: 20px; color: #fff;opacity: 0.6;"
      >
        กิจกรรมประจำเดือน
      </div>
      <v-card
      v-for="(item, i) in itemSearch.filter(
        (a) =>
          new Date(a.startDate).getTime() <= this.today.getTime() &&
          this.today.getTime() < new Date(a.endDate).getTime()
      ).filter(b => b.repeats === 'Monthly')"
      :key="i"
      class="ml-4 mr-4 mb-0 mt-8"
    >
      <v-row>
        <v-col class="col-5 pt-0 pb-0 mb-0">
          <v-img
            :src="item.pictureUrl"
            style="width: 100%; height: auto"
            class="picUrl"
          >
            <v-chip
              class="ma-2 ml-n1 mt-n1 coin_icon_small"
              color="#FF4B42"
              label
              text-color="white"
            >
              {{ item.coin }}
            </v-chip>
          </v-img>
        </v-col>
        <v-col class="col-7">
          <v-row class="font11 headline1">
            <v-col class="pl-0 pt-2 pb-3">{{ item.title }}</v-col>
          </v-row>
          <v-row class="headline1 mb-3">
              <v-btn small tile :color="item.repeatColor" dark>{{
                item.repeats
              }}</v-btn>
              <v-btn small :color="item.typeColor" dark>{{
                item.type
              }}</v-btn>
          </v-row>
                    <v-row style="text-shadow: 3px 3px 2px #D8D2CB;">ใช้ได้ถึง {{item.endDate}}</v-row>
          <v-row class="font14 icon2">
            <v-col class="pt-1 text-end pr-6">
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse < item.quota"
                color="green darken-4"
                >รับแล้ว</v-chip
              >
              <v-chip
                small
                dark
                v-if="item.statusChk && item.countUse >= item.quota"
                color="green darken-4"
                >มีคนเข้าร่วมกิจกรรมครบแล้ว</v-chip
              >
              <v-btn
                v-if="!item.statusChk && item.countUse < item.quota"
                style="box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);"
                outlined
                rounded
                small
                color="#FF4B42"
                @click="submit(item)"
                >เก็บคะแนน</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-card-actions class="mx-0 px-0 pt-3 pb-0">
        <v-progress-linear
          :v-model="(item.countUse * 100) / item.quota"
          height="25"
        >
          <v-icon right :color="'#7CCC63'"> mdi-account </v-icon>
          <strong>{{ item.countUse }} / {{ item.quota }} </strong>
        </v-progress-linear>
      </v-card-actions>
    </v-card>
    </div> -->
    <!-- <v-row class="ml-1 mr-1">
      <v-col class="text-center">
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('OneTime'), (dialog = false)"
            color="red"
          >
            One Time
            <v-icon right> mdi-numeric-1-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Daily'), (dialog = false)"
            color="green"
          >
            Daily
            <v-icon right> mdi-alpha-d-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Weekly'), (dialog = false)"
            color="primary"
          >
            Weekly
            <v-icon right> mdi-alpha-w-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            @click="search('Monthly'), (dialog = false)"
            color="deep-purple"
          >
            Monthly
            <v-icon right> mdi-alpha-m-box </v-icon>
          </v-btn>
        </v-col>
        <v-col style="padding: 0;">
          <v-btn
            class="ma-2 short"
            outlined
            small
            color="indigo"
            @click="search('All'), (dialog = false)"
          >
            ทั้งหมด
            <v-icon right> mdi-alpha-a-box </v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row> -->
    <div class="text-center">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{ $t("message.PleaseSelect") }}
          </v-card-title>

          <v-card-text>
            <layout>
              <v-row class="ml-1 mr-1">
                <v-col class="text-center">
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('OneTime'), (dialog = false)"
                    color="red"
                  >
                    One Time
                    <v-icon right> mdi-numeric-1-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Daily'), (dialog = false)"
                    color="green"
                  >
                    Daily
                    <v-icon right> mdi-alpha-d-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Weekly'), (dialog = false)"
                    color="primary"
                  >
                    Weekly
                    <v-icon right> mdi-alpha-w-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    @click="search('Monthly'), (dialog = false)"
                    color="deep-purple"
                  >
                    Monthly
                    <v-icon right> mdi-alpha-m-box </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2 short"
                    outlined
                    small
                    color="indigo"
                    @click="search('All'), (dialog = false)"
                  >
                  {{ $t("message.all") }}
                    <v-icon right> mdi-alpha-a-box </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog v-model="dialogDoc" persistent scrollable fullscreen>
        <v-card>
            <v-card-text>
              <v-form ref="form_add" v-model="valid" lazy-validation>
              <v-container class="pl-4 pr-4 pt-5">
                <v-row justify="center">
                  <v-col cols="3">
                    <v-img
                      :src="require('@/assets/activityAdd.svg')"
                      height="48px"
                      width="42px"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col class="text-center">
                    <b class="font24">{{ $t("message.EnterData") }}</b>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.field1Title">
                  <v-col cols="12">
                    <div>
                      <p style="font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 1</p>
                      <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate.field1Title[0] : formUpdate.field1Title[1] }}</p>
                    </div>
                    <v-textarea
                      v-if="formUpdate.field1Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field1Type === 'citizenNumber'
                          ? [formUpdate.key1.email]
                          : formUpdate.field1Type === 'email'
                          ? [formUpdate.key1.email]
                          : [formUpdate.key1.required]
                      "
                      required
                      v-model="formUpdateItem.field1Value"
                    ></v-textarea>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field1Value"
                          :label="formUpdate.field1Title"
                          readonly
                          v-if="formUpdate.field1Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker1"
                        v-model="formUpdateItem.field1Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save1"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.field2Title">
                  <v-col cols="12">
                    <div>
                      <p style="font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 1</p>
                      <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate.field2Title[0] : formUpdate.field2Title[1] }}</p>
                    </div>
                    <v-textarea
                      v-if="formUpdate.field2Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field2Type === 'citizenNumber'
                          ? [formUpdate.key1.email]
                          : formUpdate.field2Type === 'email'
                          ? [formUpdate.key1.email]
                          : [formUpdate.key1.required]
                      "
                      required
                      v-model="formUpdateItem.field2Value"
                    ></v-textarea>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field2Value"
                          :label="formUpdate.field2Title"
                          readonly
                          v-if="formUpdate.field2Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker1"
                        v-model="formUpdateItem.field2Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save1"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.field3Title">
                  <v-col cols="12">
                    <div>
                      <p style="font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 1</p>
                      <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate.field3Title[0] : formUpdate.field3Title[1] }}</p>
                    </div>
                    <v-text-field
                      v-if="formUpdate.field3Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field3Type === 'citizenNumber'
                          ? [formUpdate.key1.email]
                          : formUpdate.field3Type === 'email'
                          ? [formUpdate.key1.email]
                          : [formUpdate.key1.required]
                      "
                      v-model="formUpdateItem.field3Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field3Value"
                          :label="formUpdate.field3Title"
                          readonly
                          v-if="formUpdate.field3Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker3"
                        v-model="formUpdateItem.field3Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save3"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="formUpdate.field4Title">
                  <v-col cols="12">
                    <div>
                      <p style="font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} 1</p>
                      <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 15px;border-radius: 10px;">{{ $i18n.locale === 'th' ? formUpdate.field4Title[0] : formUpdate.field4Title[1] }}</p>
                    </div>
                    <v-text-field
                      v-if="formUpdate.field4Type !== 'dateTime'"
                      outlined
                      dense
                      :rules="
                        formUpdate.field4Type === 'citizenNumber'
                          ? [formUpdate.key1.email]
                          : formUpdate.field4Type === 'email'
                          ? [formUpdate.key1.email]
                          : [formUpdate.key1.required]
                      "
                      required
                      v-model="formUpdateItem.field4Value"
                    ></v-text-field>
                    <v-menu
                      ref="menu4"
                      v-model="menu4"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formUpdateItem.field4Value"
                          :label="formUpdate.field4Title"
                          prepend-icon="event"
                          readonly
                          v-if="formUpdate.field4Type == 'dateTime'"
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker4"
                        v-model="formUpdateItem.field4Value"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save4"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
               </v-form>
            </v-card-text>
            <v-divider style="margin: 0;"></v-divider>
            <v-card-actions class="text-center" style="justify-content: space-evenly;padding-bottom:20px">
                  <v-btn
                    class="white--text"
                    color="#69dd61"
                    width="auto"
                    style="border-radius: 15px;font-size: 16px;"
                    :disabled="!valid"
                    @click="successAlert = true"
                  >
                  🎁 {{ $t("message.get") }}{{ $t("message.point") }}
                  </v-btn>
                  <v-btn
                    rounded
                    color="#808588"
                    dark
                    width="100px"
                    @click="dialogDoc = false, clear()"
                  >
                    {{ $t("message.cancle") }}
                  </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="Choice " persistent scrollable fullscreen>
      <v-card v-if="question">
            <v-card-text>
              <v-container class="pl-4 pr-4 pt-5">
                <div style="text-align: center;">{{ $t("message.answer") }} {{JSON.parse(question.answerChoice).length}} {{ $t("message.questions") }} {{ $t("message.forGet") }} {{question.coin}} {{ $t("message.point") }} !</div>
                <v-col v-for="(item, i) in JSON.parse(question.answerChoice)" :key="i">
                  <div>
                    <p style="font-weight: bold;margin-bottom: 6px;"> <v-icon class="mr-1">mdi-chat-question</v-icon>{{ $t("message.noQuestions") }} {{i + 1}}</p>
                    <p style="padding: 5px;background-color: rgba(0, 0, 0, 0.08);font-size: 20px;border-radius: 10px;">{{ $i18n.locale === 'th' ? item[0].split('/')[0] : item[0].split('/')[1] === '' ? item[0].split('/')[0] : item[0].split('/')[1]}} ?</p>
                  </div>
                  <div  v-if="question.answerType === 'คำตอบแบบ 1 ตัวเลือก'" style="padding: 10px;background-color: rgb(0 0 0 / 8%);border-radius: 10px;">
                    <div style="padding-left: 5px;font-weight: bold;margin-bottom: 5px;">* {{ $t("message.oneAnswer") }}</div>
                    <div v-for="(item2, index) in item.filter((value, index) => { return index > 0})" :key="index">
                      <v-card :class="(answer1Choice !== null && answer1Choice[i][1] === item2) ? 'activeAnswer': 'answer'" @click="select1Choice(item2,i)">
                        <div>{{$i18n.locale === 'th' ? item2.split('/')[0] : item2.split('/')[1] === '' ? item2.split('/')[0] : item2.split('/')[1]}}</div>
                        <v-icon color="white" v-if="answer1Choice !== null && answer1Choice[i][1] === item2">mdi-check-circle</v-icon>
                        <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                    </div>
                  </div>
                  <div  v-if="question.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก'" style="padding: 10px;background-color: rgb(0 0 0 / 8%);border-radius: 10px;">
                    <div style="padding-left: 5px;font-weight: bold;margin-bottom: 5px;">* {{ $t("message.moreChoice") }}</div>
                    <div v-for="(item2, index) in item.filter((value, index) => { return index > 0})" :key="index">
                      <v-card :class="answer1Choice !== null && answer1Choice[i].filter((value2, index2) =>  index2 > 0).some(item10 =>  item10  === item2) ? 'activeAnswer': 'answer'" @click="select1Choice(item2,i)">
                        <div>{{$i18n.locale === 'th' ? item2.split('/')[0] : item2.split('/')[1] === '' ? item2.split('/')[0] : item2.split('/')[1]}}</div>
                        <v-icon color="white" v-if="answer1Choice !== null && answer1Choice[i].filter((value2, index2) =>  index2 > 0).some(item10 =>  item10  === item2)">mdi-check-circle</v-icon>
                        <v-icon color="grey" v-else>mdi-checkbox-blank-circle-outline</v-icon>
                      </v-card>
                    </div>
                  </div>
                  <v-divider></v-divider>
                </v-col>
              </v-container>
            </v-card-text>
            <v-divider style="margin: 0;"></v-divider>
            <v-card-actions class="text-center" style="justify-content: space-evenly;padding-bottom:20px">
                  <v-btn
                    class="white--text"
                    color="#69dd61"
                    width="auto"
                    style="border-radius: 15px;font-size: 16px;"
                    :disabled="statusCheckAnswer"
                    @click="successAlert = true"
                    large
                  >
                    🎁 {{ $t("message.get") }} {{question.coin}} {{ $t("message.point") }}
                  </v-btn>
                  <v-btn
                    color="#808588"
                    style="border-radius: 15px;font-size: 16px;"
                    dark
                    width="100px"
                    @click="clear()"
                    large
                  >
                  {{ $t("message.cancle") }}
                  </v-btn>
            </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="success" persistent>
      <v-card class="pa-7">
        <v-row>
          <v-col class="text-center"
            ><img
                    v-if="profile.pictureUrl"
                    style="
                      border-color: white;
                      height: 70px;
                    "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center pb-0"
            ><span class="headline1 font28 weight1000"
              >{{ $t("message.addPoint") }}</span
            ></v-col
          >
        </v-row>
        <v-row v-if="point">
          <v-col class="text-center pa-0"
            ><span class="headline1 font55 weight1000">{{ point }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0"
            ><span class="headline1 font28 weight1000">{{ $t("message.point") }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn rounded class="btn_icon1" dark @click="$router.push('home')">
              {{ $t("message.seePoint") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successAlert" persistent>
      <v-card class="pa-7">
        <v-row justify="center" align="center">
          <v-col cols="3">
            <v-img
              :src="require('@/assets/activityV.svg')"
              height="48px"
              width="36px"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <b class="font24">{{ $t("message.confirmGetReward") }}</b>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="10">
            <v-img
              :src="require('@/assets/activityChk.svg')"
              height="210px"
              width="224.36px"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <b class="font13">{{ $t("message.getFreePoint") }}!!!</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <div style="margin-right: 8px;padding-top: 10px;display: flex;justify-content: center;margin-bottom: 7px;">
                <div class="mr-3"><img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 25px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                /></div>
                <b class="font20">{{ coinChk }} </b>
            </div>
          </v-col>
        </v-row>
        <div class="text-center">
           <v-progress-circular
            indeterminate v-if="getBtn === false"
          ></v-progress-circular>
          <v-btn
            v-if="getBtn === true"
            rounded
            color="#C62929"
            dark
            width="100px"
            @click="changbtn() ,useActivity()"
          >
            Get
          </v-btn>
          <v-btn
            v-if="getBtn === true"
            rounded
            color="#808588"
            dark
            width="100px"
            @click="successAlert = false"
          >
            {{ $t("message.cancle") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-bottom-sheet
      v-if="levelUpdate"
      v-model="levelup"
      persistent
      hide-on-scroll
      overlay-opacity="1"
    >
      <v-sheet class="text-center" height="75vh">
        <v-img
          src="/static/img/papershoot.png"
          style="position: absolute; top: 0"
        />
        <v-img
          src="/static/img/golden.png"
          max-width="300"
          max-height="392"
          style="position: absolute; top: 60px; left: 35px"
        />
        <v-row style="padding-top: 240px">
          <v-col class="text-center pb-0"
            ><span class="headline1 font55 bold">Congrats!</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pb-0"
            ><span class="headline2 font18 bold"
              >{{ $t("message.addPoint") }}</span
            ></v-col
          >
        </v-row>
        <v-row v-if="point">
          <v-col class="text-center pa-0"
            ><span class="headline2 font24 weight1000">{{ point }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0"
            ><span class="headline2 font18 bold">{{ $t("message.point") }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0 pb-0"
            ><span class="headline1 font24 bold"
              >{{ $t("message.upLevel") }}</span
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-center pt-0 pb-3"
            ><span class="headline1 font28 weight1000">{{
              levelUpdate.name }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col class="ml-5 mr-5 text-center">
            <v-btn
              rounded
              class="btn_icon1"
              dark
              @click="$router.push('privilege')"
            >
            {{ $t("message.seeMorePre") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<style scoped>
.short {
  width: 200px;
}
.short span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.picUrl {
  border-radius: 10px 10px 10px 10px;
}
</style>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment' // แปลง date
export default {
  name: 'AllActivity',
  data () {
    return {
      // activePicker: null,
      repeatCaption: {
        OneTime: 'รับได้ครั้งเดียว',
        Daily: 'รับได้วันละครั้ง',
        Weekly: 'รับได้สัปดาห์ละครั้ง',
        Monthly: 'รับได้เดือนละครั้ง'
      },
      today: new Date(),
      menu1: false,
      thai: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      menu2: false,
      menu3: false,
      getBtn: true,
      value: 0,
      menu4: false,
      dialog: false,
      dialogDoc: false,
      successAlert: false,
      valid: true,
      success: false,
      levelup: false,
      levelUpdate: null,
      point: null,
      level: null,
      member: null,
      Choice: false,
      statusActivityFriendGetFriend: false,
      searchText: '',
      items: [],
      itemSearch: [],
      shopId: null,
      question: null,
      coinChk: '',
      answer1Choice: null,
      statusCheckAnswer: true,
      showActivity: false,
      cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 }
      ],
      // itemCheck: [],
      tab: 0,
      formUpdate: {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      },
      formUpdateItem: {
        field1Value: '',
        field2Value: '',
        field3Value: '',
        field4Value: ''
      }
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    },
    menu2 (val) {
      val && setTimeout(() => (this.$refs.picker2.activePicker = 'YEAR'))
    },
    menu3 (val) {
      val && setTimeout(() => (this.$refs.picker3.activePicker = 'YEAR'))
    },
    menu4 (val) {
      val && setTimeout(() => (this.$refs.picker4.activePicker = 'YEAR'))
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()

    // await this.getFriendForCheck()
    await this.getActivity()
    await this.getFriendForCheck()
    await this.getLevelDB()
    if (this.$route.query.activityId) {
      this.addData()
    }
    // await this.getChkActivity()
  },
  async updated () {
    this.level = this.getLevel()
    // await this.getChkActivity()
  },
  methods: {
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    translateFunction () {
      this.googleTranslateElementInit()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          // this.setLevel(result)
          this.level = result
          return result
        }
      }
    },
    async getFriendForCheck () {
      const result = await this.callBeTaskAPI(
        'get',
        '/FriendGetFriend/get?shopId=' + this.shopId
      )
      if (result) {
        if (result.length > 0) {
          if (result[0].statusUpdateA === 'True' || result[0].statusUpdateB === 'True') {
            this.statusActivityFriendGetFriend = true
          } else {
            this.statusActivityFriendGetFriend = false
          }
        }
      }
    },
    select1Choice (item2, i) {
      if (this.question.answerType === 'คำตอบแบบ 1 ตัวเลือก') {
        if (this.answer1Choice[i].some(a => a === item2)) {
          const index = this.answer1Choice[i].indexOf(item2)
          this.answer1Choice[i].splice(index, 1)
        } else {
          if (this.answer1Choice[i].length === 1) {
            this.answer1Choice[i].push(item2)
          } else if (this.answer1Choice[i].length > 1) {
            this.answer1Choice[i].splice(1, 1)
            this.answer1Choice[i].push(item2)
          }
        }
      } else if (this.question.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
        if (this.answer1Choice[i].some(a => a === item2)) {
          const index = this.answer1Choice[i].indexOf(item2)
          this.answer1Choice[i].splice(index, 1)
        } else {
          this.answer1Choice[i].push(item2)
        }
      }
      this.checkAnswer()
    },
    clear () {
      this.answer1Choice = null
      this.Choice = false
      this.statusCheckAnswer = true
      this.formUpdateItem.field1Value = ''
      this.formUpdateItem.field2Value = ''
      this.formUpdateItem.field3Value = ''
      this.formUpdateItem.field4Value = ''
    },
    alertGetcoin () {
      alert(`${this.$t('message.thisAlreadyActivity')}`)
    },
    test (item) {
    },
    queryAndIndeterminate () {
      this.value = 0

      var intval = setInterval(() => {
        if (this.percentage < 70) { this.percentage += 0.5 } else { clearInterval(intval) }
      }, 10)
    },
    clearMessage () {
      this.searchText = ''
    },
    save1 (date) {
      this.$refs.menu1.save(date)
    },
    save2 (date) {
      this.$refs.menu2.save(date)
    },
    save3 (date) {
      this.$refs.menu3.save(date)
    },
    save4 (date) {
      this.$refs.menu4.save(date)
    },
    validate () {
      this.$nextTick(() => {
        let self = this
        self.$refs.form_add.validate()
      })
    },
    checkTypeactivityFortexthearder (item) {
      if (item.type === 'FreeCoin') {
        if (item.repeats === 'OneTime') {
          return this.$i18n.locale === 'th' ? '🎊 รับคะแนนฟรี!' : '🎊 get free point!'
        } else if (item.repeats === 'Daily') {
          return this.$i18n.locale === 'th' ? '🎊 รับคะแนนฟรี ทุกวัน!' : '🎊 get free point every day!'
        } else if (item.repeats === 'Weekly') {
          return this.$i18n.locale === 'th' ? '🎊 รับคะแนนฟรี ทุกสัปดาห์!' : '🎊 get free point every week!'
        } else if (item.repeats === 'Monthly') {
          return this.$i18n.locale === 'th' ? '🎊 รับคะแนนฟรี ทุกเดือน!' : '🎊 get free point every mounth!'
        }
      } else if (item.type === 'กรอกข้อมูล') {
        return this.$i18n.locale === 'th' ? '🎊 ตอบคำถามรับคะแนนฟรี!' : '🎊 Answer questions to earn free points!'
      }
    },
    search (repeats) {
      this.searchText = repeats
      if (repeats === 'All') {
        this.itemSearch = this.items
      } else {
        var dataCheck = this.items.filter(function (el) {
          return el.repeats === repeats
        })
        this.itemSearch = dataCheck
      }
    },
    async getActivity () {
      const result = await this.callBeTaskAPIActivity(
        'get',
        '/activity/line/get/font'
      )
      // console.log('result222', result)
      if (result.length > 0) {
        let rs = result.filter(a => a.type !== 'video')
        if (this.$eventShopOption(this.shopId, 'activitiesInOrder')) {
          // ร้านอีเวนต์: เรียงตามลำดับที่สร้าง (คำถามข้อ 1 อยู่บนสุด) API ส่งมาใหม่สุดก่อน
          rs = rs.slice().reverse()
        }
        for (var i = 0; i < rs.length; i++) {
          var d = rs[i]
          var url = ''
          if (d.repeats === 'OneTime') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&memberId=' +
              this.profile.memberId
            d.repeatColor = '#FC9590'
          }
          if (d.repeats === 'Daily') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&memberId=' +
              this.profile.memberId +
              '&joinDate=' +
              moment(new Date()).format('YYYY-MM-DD')
            d.repeatColor = '#B3E48E'
          }
          if (d.repeats === 'Weekly') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&memberId=' +
              this.profile.memberId +
              '&joinWeek=' +
              moment(new Date(), 'YYYYMMDD').isoWeek() +
              '&joinYear=' +
              moment(new Date()).format('YYYY')
            d.repeatColor = '#327BC7'
          }
          if (d.repeats === 'Monthly') {
            url =
              '/activityLog/line/get?activityId=' +
              d.activityId +
              '&shopId=' +
              d.shopId +
              '&memberId=' +
              this.profile.memberId +
              '&joinMonth=' +
              moment(new Date()).format('MM') +
              '&joinYear=' +
              moment(new Date()).format('YYYY')
            d.repeatColor = '#6445AB'
          }
          if (d.type === 'กรอกข้อมูล') {
            d.typeColor = '#F56867'
          }
          if (d.type === 'FreeCoin') {
            d.typeColor = '#7CCC63'
          }
          if (d.type === 'LuckyDraw') {
            d.typeColor = '#F39C12'
          }
          const resultChk = await this.callBeTaskAPIActivity('get', url)
          if (resultChk.status === false) {
            d.statusChk = false
          } else {
            d.statusChk = true
          }
          this.items.push(d)
          this.itemSearch.push(d)
        }
        this.items = this.items.filter((a) => {
          if (a.endDate !== '') {
            return new Date(a.startDate).getTime() <= this.today.getTime() && this.today.getTime() < new Date(a.endDate).getTime()
          } else {
            return new Date(a.startDate).getTime() <= this.today.getTime()
          }
        })
        this.showActivity = true

        // console.log(
        //   'item22',
        //   this.itemSearch.filter(
        //     (a) =>
        //       new Date(a.startDate).getTime() <= this.today.getTime() &&
        //       this.today.getTime() < new Date(a.endDate).getTime()
        //   )
        // )
        // this.items = result
        // this.itemSearch = result
      }
    },
    changbtn () {
      this.getBtn = false
    },
    checkAnswer () {
      this.statusCheckAnswer = this.answer1Choice.some(a => a.length === 1)
    },
    async submit (item) {
      // console.log(
      //   new Date(this.momenDate_1(item.startDate)).getTime() <
      //     this.today.getTime()
      // )
      // console.log('startday', item.startDate)
      const result = await this.callBeTaskAPIActivity(
        'get',
        '/activity/get/filter?activityId=' + item.activityId + '&status=True'
      )
      // console.log('result222', result)
      if (!Array.isArray(result)) {
        alert(`${this.$t('message.closeActivity')}`)
        return
      }
      // console.log('today', this.today)
      // console.log(
      //   'startday',
      //   new Date(this.momenDate_1(item.startDate)).getTime()
      // )
      // console.log('end', new Date(this.momenDate_1(item.endDate)).getTime())
      // console.log('today', this.today.getTime())
      // console.log(this.formUpdateItem)
      // console.log(this.formUpdate)
      // console.log(item)
      try {
        if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบข้อความ') {
          this.formUpdate.activityId = item.activityId
          this.formUpdate.field1Title = item.field1Title ? JSON.parse(item.field1Title) : item.field1Title
          this.formUpdate.field1Type = item.field1Type
          this.formUpdate.field2Title = item.field2Title ? JSON.parse(item.field2Title) : item.field2Title
          this.formUpdate.field2Type = item.field2Type
          this.formUpdate.field3Title = item.field3Title ? JSON.parse(item.field3Title) : item.field3Title
          this.formUpdate.field3Type = item.field3Type
          this.formUpdate.field4Title = item.field4Title ? JSON.parse(item.field4Title) : item.field4Title
          this.formUpdate.field4Type = item.field4Type
          this.formUpdate.primary = item.Primary_field
          this.formUpdate.pictureUrl = item.pictureUrl
          this.formUpdate.title = item.title
          this.formUpdate.coin = item.coin
          // this.formUpdateItem.field1Value = ''
          // this.formUpdateItem.field2Value = ''
          // this.formUpdateItem.field3Value = ''
          // this.formUpdateItem.field4Value = ''

          switch (item.Primary_field) {
            case '1':
              this.formUpdate.key1 = {
                numberRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
                counterTel: (value) => value.length <= 10 || 'Max 10 characters',
                IDcardRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
                required: (value) => !!value || 'กรุณากรอก.',
                resizeImag: (value) =>
                  !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
                counterIDcard: (value) =>
                  value.length <= 13 || 'Max 13 characters',
                email: (value) => {
                  const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  return pattern.test(value) || 'Invalid e-mail.'
                }
              }
              this.formUpdate.key2 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key3 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key4 = {
                required: (value) => value.length <= 5000
              }
              // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
              break
            case '2':
              this.formUpdate.key2 = {
                numberRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
                counterTel: (value) => value.length <= 10 || 'Max 10 characters',
                IDcardRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
                required: (value) => !!value || 'กรุณากรอก.',
                resizeImag: (value) =>
                  !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
                counterIDcard: (value) =>
                  value.length <= 13 || 'Max 13 characters',
                email: (value) => {
                  const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  return pattern.test(value) || 'Invalid e-mail.'
                }
              }
              this.formUpdate.key1 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key3 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key4 = {
                required: (value) => value.length <= 5000
              }
              // this.formUpdate.chkKey = '/activityData/get?field2Value=' + this.formUpdateItem.field2Value + '&activityId=' + this.formUpdate.activityId
              break
            case '3':
              this.formUpdate.key3 = {
                numberRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
                counterTel: (value) => value.length <= 10 || 'Max 10 characters',
                IDcardRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
                required: (value) => !!value || 'กรุณากรอก.',
                resizeImag: (value) =>
                  !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
                counterIDcard: (value) =>
                  value.length <= 13 || 'Max 13 characters',
                email: (value) => {
                  const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  return pattern.test(value) || 'Invalid e-mail.'
                }
              }
              this.formUpdate.key1 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key2 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key4 = {
                required: (value) => value.length <= 5000
              }
              // this.formUpdate.chkKey = '/activityData/get?field3Value=' + this.formUpdateItem.field3Value + '&activityId=' + this.formUpdate.activityId
              break
            case '4':
              this.formUpdate.key4 = {
                numberRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                `${this.$t('message.fillNum')}`,
                counterTel: (value) => value.length <= 10 || 'Max 10 characters',
                IDcardRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
                required: (value) => !!value || 'กรุณากรอก.',
                resizeImag: (value) =>
                  !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
                counterIDcard: (value) =>
                  value.length <= 13 || 'Max 13 characters',
                email: (value) => {
                  const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  return pattern.test(value) || 'Invalid e-mail.'
                }
              }
              this.formUpdate.key1 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key2 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key3 = {
                required: (value) => value.length <= 5000
              }
              // this.formUpdate.chkKey = '/activityData/get?field4Value=' + this.formUpdateItem.field4Value + '&activityId=' + this.formUpdate.activityId
              break
            case '':
              this.formUpdate.key1 = {
                numberRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999) ||
                  `${this.$t('message.fillNum')}`,
                counterTel: (value) => value.length <= 10 || 'Max 10 characters',
                IDcardRules: (value) =>
                  (!isNaN(parseFloat(value)) &&
                  value >= 0 &&
                  value <= 9999999999999) ||
                `${this.$t('message.fillNum')}`,
                required: (value) => !!value || `${this.$t('message.fill')}`,
                resizeImag: (value) =>
                  !value ||
                value.size < 2000000 ||
                'Avatar size should be less than 2 MB!',
                counterIDcard: (value) =>
                  value.length <= 13 || 'Max 13 characters',
                email: (value) => {
                  const pattern =
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  return pattern.test(value) || 'Invalid e-mail.'
                }
              }
              this.formUpdate.key2 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key3 = {
                required: (value) => value.length <= 5000
              }
              this.formUpdate.key4 = {
                required: (value) => value.length <= 5000
              }
              // this.formUpdate.chkKey = '/activityData/get?field1Value=' + this.formUpdateItem.field1Value + '&activityId=' + this.formUpdate.activityId
              break
            default:
              break
          }
          this.validate()
          this.coinChk = item.coin
          this.dialogDoc = true
        // this.useActivity(this.formUpdate)
        } else if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบ 1 ตัวเลือก') {
          this.formUpdate.activityId = item.activityId
          this.formUpdate.field1Title = item.field1Title
          this.formUpdate.field1Type = item.field1Type
          this.formUpdate.field2Title = item.field2Title
          this.formUpdate.field2Type = item.field2Type
          this.formUpdate.field3Title = item.field3Title
          this.formUpdate.field3Type = item.field3Type
          this.formUpdate.field4Title = item.field4Title
          this.formUpdate.field4Type = item.field4Type
          this.formUpdate.primary = item.Primary_field
          this.formUpdate.pictureUrl = item.pictureUrl
          this.formUpdate.title = item.title
          this.formUpdate.coin = item.coin
          this.coinChk = item.coin
          this.answer1Choice = []
          this.Choice = true
          this.question = item
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        } else if (item.type === 'กรอกข้อมูล' && item.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
          this.formUpdate.activityId = item.activityId
          this.formUpdate.field1Title = item.field1Title
          this.formUpdate.field1Type = item.field1Type
          this.formUpdate.field2Title = item.field2Title
          this.formUpdate.field2Type = item.field2Type
          this.formUpdate.field3Title = item.field3Title
          this.formUpdate.field3Type = item.field3Type
          this.formUpdate.field4Title = item.field4Title
          this.formUpdate.field4Type = item.field4Type
          this.formUpdate.primary = item.Primary_field
          this.formUpdate.pictureUrl = item.pictureUrl
          this.formUpdate.title = item.title
          this.formUpdate.coin = item.coin
          this.coinChk = item.coin
          this.answer1Choice = []
          this.question = item
          this.Choice = true
          let arrayForquestion = JSON.parse(item.answerChoice)
          arrayForquestion.forEach(element => this.answer1Choice.push([element[0]]))
        } else {
          this.formUpdateItem.field1Value = ''
          this.formUpdateItem.field2Value = ''
          this.formUpdateItem.field3Value = ''
          this.formUpdateItem.field4Value = ''
          this.formUpdate.activityId = item.activityId
          this.successAlert = true
          this.coinChk = item.coin
        // this.useActivity(item)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    async useActivity (activity) {
      if (this.formUpdate.primary === '1') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field1Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '2') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field2Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '3') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field3Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else if (this.formUpdate.primary === '4') {
        this.formUpdate.chkKey =
          '/activityData/get?field1Value=' +
          this.formUpdateItem.field4Value +
          '&activityId=' +
          this.formUpdate.activityId
        await this.chkPrimary()
      } else {
        await this.addData()
      }
      this.getBtn = true
      //   }
      // })
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      await axios({
        method: method,
        headers: {
          shopId: this.shopId,
          lineUserId: this.profile.userId,
          memberId: this.profile.memberId,
          activityId: this.$route.query.activityId ? this.$route.query.activityId : this.formUpdate.activityId
        },
        url: this.DNS_IP + url,
        data: params
      })
        .then((response) => {
          result = response.data
        })
        .catch((error) => {
          console.error(error)
          result = null
        })
      return result
    },
    async chkPrimary () {
      const results = await this.callBeTaskAPI('get', this.formUpdate.chkKey)
      if (results.status === false) {
        await this.addData()
      } else {
        Swal.fire({
          title: `มีข้อมูลอยู่แล้ว`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ตกลง'
        }).then((confirm) => {
          if (confirm.isConfirmed) {
            location.reload()
          }
        })
      }
    },
    async addData () {
      const params = {
        field1Value: this.formUpdateItem.field1Value,
        field2Value: this.formUpdateItem.field2Value,
        field3Value: this.formUpdateItem.field3Value,
        field4Value: this.formUpdateItem.field4Value,
        answerForChoice: this.answer1Choice !== null ? JSON.stringify(this.answer1Choice) : null
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        `/activityLog/add`,
        params
      )
      if (result.status) {
        if (!this.$isEventShop(this.shopId)) {
          this.point = result.coin
          this.success = true
          await this.getMemberProfile()
          this.member = this.GET_MEMBERINFO()
        } else {
          this.items = []
          await this.getActivity() // รอให้เสร็จ
          await this.clearData()
          const count = this.items.filter(i => !i.statusChk).length
          const activity = this.items.filter(i => !i.statusChk)
          if (count === 0) {
            Swal.fire({
              title: 'ตอบคำถามครบแล้ว',
              text: 'สามมารถเอาคะแนนไปแลกของรางวัลได้เลย',
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push('/home')
              }
            })
          } else {
            Swal.fire({
              title: `คุณได้รับ ${this.$eventShopOption(this.shopId, 'showEarnedCoin') ? result.coin : 10} คะแนน`,
              text: 'กดตกลงเพื่อตอบคำถามต่อไป.',
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.successAlert = false
                this.submit(activity[0])
              }
            })
          }
        }
      } else {
        var titles = ''
        if (result.message === 'lineUserId is already') {
          titles = `คุณเคยได้รับรางวัลนี้แล้ว`
        }
        if (result.message === 'expired') {
          titles = `รางวัลนี้ หมดอายุแล้ว`
        }
        if (this.$isEventShop(this.shopId)) {

        } else {
          Swal.fire({
            title: titles,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ตกลง'
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/activity')
            }
          })
        }
      }
    },
    clearData () {
      this.formUpdateItem = {
        field1Value: '',
        field2Value: '',
        field3Value: '',
        field4Value: ''
      }

      this.formUpdate = {
        activityId: '',
        field1Title: '',
        field1Type: '',
        key1: {},
        chkKey: '',
        field2Title: '',
        field2Type: '',
        key2: {},
        field3Title: '',
        field3Type: '',
        key3: {},
        field4Title: '',
        field4Type: '',
        key4: {},
        primary: '',
        coin: '',
        pictureUrl: '',
        title: ''
      }
    }
  }
}
</script>
<style scoped>
.background {
  margin: auto;
  position: relative;
  width: 95%;
  height: 15px;
  border-radius: 15px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  box-shadow: inset 1px 2px 3px;
  /* margin-bottom: 10px; */
  background-color: #B2B2B2;
}
.strip {
    position: absolute;
    top: 1px; left: 1px; right: 1px;
    display: block;
    height: 100%;
    border-radius: 15px;
    background-size: 30px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 27px 27px;
    /* animation: animate-stripes 200s linear  infe; */
    background-color: #00ABB3;
    width: 50%;
    /* transform: scale(-1); */
}
@keyframes animate-stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 10000px 0;
  }
}
.btn {
  background: linear-gradient(0deg, #64AD00 0%, #B2E800 100%);
  border: 1px solid #B2E800;
  box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.3);
  border-radius: 31px;
  color: white !important;
}
.btn2 {
  background: linear-gradient(0deg, #edeeeb 0%, #ccccca 100%);
  border: 1px solid #b4b4b3;
  /* box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.3); */
  border-radius: 31px;
  color: white;
  display: inline-block;
  padding: 0.375rem 0.75rem;
}
.percent {
  position: sticky;
    z-index: 1;
    text-align: center;
    font-size: 10px;
    font-weight: bolder;
    color: white;
}
.image-input {
  display: block;
  height: 136px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
  border-radius: 20px;
}
.progress {
  position: relative;
  width: 60%;
  height: 15px;
  border-radius: 15px;
  overflow: hidden;
  border-bottom: 1px solid #ddd;
  box-shadow: inset 1px 2px 3px;
  margin-bottom: 10px;
  background-color: #B2B2B2;
}
.activity-card{
  border-radius: 25px !important;
  padding: 10px 0 0 0;
  /* background-color: #6683D3; */
  top: 0;
  transition: all .2s;
  position: relative;
}
.activity-card:active {
            top: 3px;
            box-shadow: 0 10px 0px #3f51b5;
            transition: all .2s;
        }
/* .fill{
  background: linear-gradient(4 5deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.5) 75%, transparent 75%, transparent);
} */
.color{
  animation: fillBar 1s forwards;
  transform: scaleX(0);
  transform-origin: 0 0;
}
@keyframes fillBar {
  to {
    transform: scaleX(1);
  }
}
.answer {
  margin-bottom: 2px;
  padding: 6px;
  text-align: center;
  transition: all ease 0.4s;
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;
  font-size: 15px;
  border-radius: 10px !important;
}
.activeAnswer {
  margin-bottom: 2px;
  padding: 6px;
  text-align: center;
  background-color: rgb(92 118 232) !important;
  transform: translateY(0px);
  color: white !important;
  transition: all ease 0.4s;
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;
  border-radius: 10px !important;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ActivityBackup.vue